import MyComponent from "../../../component/userMaster/Usertype";

const UserType=()=>{
    return <MyComponent/>
}
export default UserType;